export default __webpack_public_path__ + "static/media/swan-logo.bff5c4a5.svg";